import Vue from "vue";
import { capitalize } from "@/utils/utils";
import {
  ObterTipoAtendimentoAnonimo,
  ObterEspecialidadesAnonimo,
  ObterRegioesAnonimo,
  BuscarPorRegiaoAnonimo,
  DetalhePrestadorAnonimo,
  ObterPlanosAtendidos,
  ObterPlanosCategoriasAnonimo
} from "@/api/redeCredenciadaAnonimo";

const initialState = {
  selectedState: null,
  selectedCity: null,
  selectedNeighborhood: null,
  selectedSpecialty: null,
  selectedSubSpecialty: null,
  selectedFilters: {},
  selectedSort: "",
  selectedTextSearch: "",
  selectedNetwork: null,
  selectedFacility: null,
  selectedLanguage: null,
  selectedEstablishmentType: null,
  selectedPlanCategory: null,
  selectedPlanName: null,
  tipoAtendimentoAnonimo: null,
  especialidadesAnonimo: null,
  regioesAnonimo: null,
  categoriasPlanosAnonimo: [],
  planosAnonimo: [],
  planosAtendidos: [],
  rede: "",
  inativos: false,
  prestadores: [],
  doctorDetail: {},
  loadingDoctorDetail: false,
  selectedProvider: {}
};

export default {
  namespaced: true,
  state: () => ({ ...initialState }),
  mutations: {
    SET_STATE(state, value) {
      Vue.set(state, "selectedState", value);
    },
    SET_CITY(state, value) {
      Vue.set(state, "selectedCity", value);
    },
    SET_NEIGHBORHOOD(state, value) {
      Vue.set(state, "selectedNeighborhood", value);
    },
    SET_SPECIALTY(state, value) {
      Vue.set(state, "selectedSpecialty", value);
    },
    SET_SUBSPECIALTY(state, value) {
      Vue.set(state, "selectedSubSpecialty", value);
    },
    SET_FILTERS(state, filters) {
      Vue.set(state, "selectedFilters", filters);
    },
    SET_SORT(state, sort) {
      Vue.set(state, "selectedSort", sort);
    },
    SET_TEXT_SEARCH(state, value) {
      Vue.set(state, "selectedTextSearch", value);
    },
    SET_NETWORK(state, value) {
      Vue.set(state, "selectedNetwork", value);
    },
    SET_FACILITY(state, value) {
      Vue.set(state, "selectedFacility", value);
    },
    SET_LANGUAGE(state, value) {
      Vue.set(state, "selectedLanguage", value);
    },
    SET_ESTABLISHMENT_TYPE(state, value) {
      Vue.set(state, "selectedEstablishmentType", value);
    },
    SET_PLAN_CATEGORY(state, value) {
      Vue.set(state, "selectedPlanCategory", value);
    },
    SET_PLAN_NAME(state, value) {
      Vue.set(state, "selectedPlanName", value);
    },
    SET_TIPO_ATENDIMENTO_ANONIMO(state, value) {
      Vue.set(state, "tipoAtendimentoAnonimo", value);
    },
    SET_REDE(state, value) {
      Vue.set(state, "rede", value);
    },
    SET_ESPECIALIDADES_ANONIMO(state, value) {
      Vue.set(state, "especialidadesAnonimo", value);
    },
    SET_REGIOES_ANONIMO(state, value) {
      Vue.set(state, "regioesAnonimo", value);
    },
    SET_CATEGORIAS_PLANOS_ANONIMO(state, value) {
      Vue.set(state, "categoriasPlanosAnonimo", value);
    },
    SET_PLANOS_ANONIMO(state, value) {
      Vue.set(state, "planosAnonimo", value);
    },
    SET_PLANOS_ATENDIDOS(state, value) {
      Vue.set(state, "planosAtendidos", value);
    },
    RESET_FLOW(state) {
      Object.keys(initialState).forEach(key => Vue.set(state, key, initialState[key]));
    },
    SET_INATIVOS(state, value) {
      Vue.set(state, "inativos", value);
    },
    SET_PRESTADORES(state, value) {
      Vue.set(state, "prestadores", value);
    },
    SET_DOCTOR_DETAIL(state, value) {
      Vue.set(state, "doctorDetail", value);
    },
    SET_LOADING_DOCTOR_DETAIL(state, value) {
      Vue.set(state, "loadingDoctorDetail", value);
    },
    SET_SELECTED_PROVIDER(state, value) {
      Vue.set(state, "selectedProvider", value);
    },
    RESET_CONTEXT(state) {
      Object.keys(initialState).forEach(key => Vue.set(state, key, initialState[key]));
    },
    LOGOUT_USER(state) {
      Object.keys(initialState).forEach(key => Vue.set(state, key, initialState[key]));
    }
  },
  actions: {
    setState({ commit }, value) {
      commit("SET_STATE", value);
    },
    setCity({ commit }, value) {
      commit("SET_CITY", value);
    },
    setNeighborhood({ commit }, value) {
      commit("SET_NEIGHBORHOOD", value);
    },
    setSpecialty({ commit }, value) {
      commit("SET_SPECIALTY", value);
    },
    setSubSpecialty({ commit }, value) {
      commit("SET_SUBSPECIALTY", value);
    },
    setFilters({ commit }, filters) {
      commit("SET_FILTERS", filters);
    },
    setSort({ commit }, sort) {
      commit("SET_SORT", sort);
    },
    setTextSearch({ commit }, value) {
      commit("SET_TEXT_SEARCH", value);
    },
    setNetwork({ commit }, value) {
      commit("SET_NETWORK", value);
    },
    setFacility({ commit }, value) {
      commit("SET_FACILITY", value);
    },
    setLanguage({ commit }, value) {
      commit("SET_LANGUAGE", value);
    },
    setEstablishmentType({ commit }, value) {
      commit("SET_ESTABLISHMENT_TYPE", value);
    },
    setPlanCategory({ commit }, value) {
      commit("SET_PLAN_CATEGORY", value);
    },
    setPlanName({ commit }, value) {
      commit("SET_PLAN_NAME", value);
    },
    resetRegioesAnonimo({ commit, dispatch }) {
      commit("SET_REGIOES_ANONIMO", null);
      dispatch("setState", null);
    },
    async fetchTipoAtendimentoAnonimo(context) {
      if (context.state.tipoAtendimentoAnonimo) {
        return context.state.tipoAtendimentoAnonimo;
      }

      const result = (await ObterTipoAtendimentoAnonimo({ rede: context.state.rede }))?.Data || [];

      context.commit("SET_TIPO_ATENDIMENTO_ANONIMO", result);

      return result;
    },
    async fetchEspecialidadesAnonimo(context, { rede, nomeEspecialidade = "" }) {
      const tipoAtendimento = context.state.selectedEstablishmentType?.TipoView;

      if (context.state.especialidadesAnonimo && context.state.especialidadesAnonimo.length > 0) {
        return;
      }

      const result = await ObterEspecialidadesAnonimo({
        rede,
        tipoAtendimento,
        inativos: context.state.inativos,
        nomeEspecialidade
      });

      if (result?.Data) {
        context.commit("SET_ESPECIALIDADES_ANONIMO", result.Data);
        return result.Data;
      }

      return [];
    },
    async fetchRegioesAnonimo(context, { rede, tipoAtendimento, codigoEspecialidade, subEspecialidade }) {
      if (context.state.regioesAnonimo) {
        return;
      }

      const result = await ObterRegioesAnonimo({
        rede,
        tipoAtendimento,
        codigoEspecialidade,
        subEspecialidade,
        inativos: context.state.inativos
      });

      if (result?.Data?.Regioes) {
        context.commit("SET_REGIOES_ANONIMO", result.Data.Regioes);
        return result.Data.Regioes;
      }

      return [];
    },
    async fetchPlanosAtendidos(context, { codigoPrestador }) {
      const result = await ObterPlanosAtendidos({
        rede: context.state.rede,
        codigoPrestador
      });

      if (result?.Data) {
        context.commit("SET_PLANOS_ATENDIDOS", result.Data);
        return result.Data;
      }

      return [];
    },
    async buscarPorRegiaoAnonimo({ commit, state }, params = {}) {
      try {
        const result = await BuscarPorRegiaoAnonimo({
          rede: state.rede,
          tipoAtendimento: state.selectedEstablishmentType?.TipoView,
          codigoEspecialidade: state.selectedSpecialty?.CodigoEspecialidade,
          subEspecialidade: state.selectedSpecialty?.subEspecialidade || "",
          codigoEstado: state.selectedState,
          cidade: state.selectedCity,
          bairro: state.selectedNeighborhood,
          inativos: state.inativos,
          ...params
        });

        if (result?.Data) {
          commit("SET_PRESTADORES", result.Data);
          return result.Data;
        }

        commit("SET_PRESTADORES", []);
        return [];
      } catch (error) {
        console.error("Erro ao buscar prestadores por região:", error);
        commit("SET_PRESTADORES", []);
        return [];
      }
    },
    async detalhePrestadorAnonimo({ commit, state }, { codigoPrestador, srEndereco, completo = true }) {
      commit("SET_LOADING_DOCTOR_DETAIL", true);

      try {
        const result = await DetalhePrestadorAnonimo({
          rede: state.rede,
          codigoPrestador,
          srEndereco,
          inativos: state.inativos,
          completo
        });

        if (result?.Data) {
          commit("SET_DOCTOR_DETAIL", result.Data);
          return result.Data;
        }

        commit("SET_DOCTOR_DETAIL", null);
        return null;
      } catch (error) {
        console.error("Erro ao buscar detalhes do prestador:", error);
        commit("SET_DOCTOR_DETAIL", null);
        return null;
      } finally {
        commit("SET_LOADING_DOCTOR_DETAIL", false);
      }
    },
    async fetchPlanosCategoriasAnonimo({ commit, state, dispatch }, params) {
      if (state.planosAnonimo && state.planosAnonimo.length > 0) {
        return;
      }

      const { linha = "", codPlano = "" } = params ?? {};
      const result = await ObterPlanosCategoriasAnonimo({ linha, codPlano });

      if (result?.Data) {
        commit("SET_PLANOS_ANONIMO", result.Data);
        await dispatch("createCategoriasPlanosAnonimo", result.Data);
        return result.Data;
      }

      commit("SET_PLANOS_ANONIMO", []);
      return [];
    },
    resetFlow({ commit }) {
      commit("RESET_FLOW");
    },
    setSelectedProvider({ commit }, provider) {
      commit("SET_SELECTED_PROVIDER", provider);
    },
    createCategoriasPlanosAnonimo({ commit }, value) {
      if (!value || value?.length === 0) {
        return;
      }

      const categorias = new Set(value?.map(p => p.DsLinha));
      const options = [];
      categorias.forEach(categoria => {
        const planos = value.filter(p => p.DsLinha === categoria);
        options.push({
          value: categoria,
          label: categoria.toUpperCase() === "OMINT" ? "Premium" : capitalize(categoria),
          planos: planos.map(p => ({
            value: p.CdRede,
            label: `${p.CdPlano} - ${capitalize(p.DsPlano)}`
          }))
        });
      });
      commit("SET_CATEGORIAS_PLANOS_ANONIMO", options);
    }
  },
  getters: {
    getSelectedState: state => state.selectedState,
    getSelectedCity: state => state.selectedCity,
    getSelectedNeighborhood: state => state.selectedNeighborhood,
    getSelectedSpecialty: state => state.selectedSpecialty,
    getSelectedSubSpecialty: state => state.selectedSubSpecialty,
    getSelectedFilters: state => state.selectedFilters,
    getSelectedSort: state => state.selectedSort,
    getSelectedTextSearch: state => state.selectedTextSearch,
    getSelectedNetwork: state => state.selectedNetwork,
    getSelectedFacility: state => state.selectedFacility,
    getSelectedLanguage: state => state.selectedLanguage,
    getSelectedPlanCategory: state => state.selectedPlanCategory,
    getSelectedPlanName: state => state.selectedPlanName,
    getTipoAtendimentoAnonimo: state => state.tipoAtendimentoAnonimo,
    getEspecialidadesAnonimo: state => state.especialidadesAnonimo,
    getRegioesAnonimo: state => state.regioesAnonimo,
    getPlanosAnonimo: state => state.planosAnonimo,
    getPlanosAtendidos: state => state.planosAtendidos,
    getEstablishmentDescription: state => state.selectedEstablishmentType?.DescricaoTipoAtendimento || "",
    getPrestadores: state => state.prestadores,
    getDoctorDetail: state => state.doctorDetail,
    getLoadingDoctorDetail: state => state.loadingDoctorDetail,
    getSelectedProvider: state => state.selectedProvider
  }
};
